import { combineReducers } from 'redux';

import agreement from './agreement/agreementReducer';

export default combineReducers({
	agreement,
});
